export const PERCENTILES_PATH = 'percentiles';
